import { render, staticRenderFns } from "./OfferItemThemeCore.vue?vue&type=template&id=22c5812f"
import script from "./OfferItemThemeCore.vue?vue&type=script&lang=js"
export * from "./OfferItemThemeCore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports